import { render, staticRenderFns } from "./UpdateBlock.vue?vue&type=template&id=b7e839a2&scoped=true"
import script from "./UpdateBlock.vue?vue&type=script&lang=js"
export * from "./UpdateBlock.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7e839a2",
  null
  
)

export default component.exports